import { Icon } from '@/kit/Icon';
import { TabGroup } from '@/kit/Tabs';
import { FirmNoteTexts } from './FirmNoteTexts';
import { Tooltip } from '@/kit/Tooltip';
import {
  AccountantLinesTab,
  PolicyTab,
  SMALL_BUSINESS_LAYOUT,
  useReportNotesSettings,
} from './ReportNotesSettingsBase';

/**
 * Angular PartnershipComponent: `/home/settings/partnership`. A partnership carries the same accounting policy
 * headings as a sole trader.
 */
export function Partnership() {
  const notes = useReportNotesSettings('partnership', SMALL_BUSINESS_LAYOUT);

  return (
    <div className="form wp-100">
      <div className="sidenav-details emoji-sec pt-5">
        <div className="highlight-details">
          <Tooltip title="Accountants can update 'Accounting Policies' or related notes for all the Partnership Firms as default from this section. These notes will then reflect in the accounts reports for all the Partnership clients as default.">
            <Icon name="emoji_objects" className="text-yellow-200 highlight-icon" />
          </Tooltip>
        </div>
        <div className="sidenav-body">
          <TabGroup
            alignTabs="start"
            tabs={[
              {
                label: 'Accountant’s Report',
                infoText: "Default wording for the accountant's report, applied to every Partnership client.",
                children: <AccountantLinesTab notes={notes} />,
              },
              {
                label: 'Accounting Policy',
                infoText: 'Default accounting policy wording used in the notes to the accounts.',
                children: <PolicyTab notes={notes} rowClassName="d-flex gap-30 pt-10" />,
              },
              {
                label: 'Default Note Text',
                infoText: 'Firm-wide default text for the other standard notes to the accounts.',
                children: <FirmNoteTexts settingsKey="partnership" />,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
